<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@buyNewSponsor">Buy New Sponsor</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addPromotionForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@numberOfPromotionsLabel">Number of promotion codes</mat-label>
        <input data-testid="promotions_count" (keypress)="numberOnly($event)" matInput id="codesNumber" i18n-placeholder="@@numberOfPromotionsPlaceholder" placeholder="Number of promotion codes" name="codesNumber" formControlName="codesNumber" required />
        <mat-error>
          @if (!addPromotionForm.get('codesNumber').valid && addPromotionForm.get('codesNumber').touched) {
            @if (addPromotionForm.get('codesNumber').errors && addPromotionForm.get('codesNumber').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div>
      <button i18n="@@buy" data-testid="add_promotions_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Buy</button>
    </div>
  </form>
</mat-dialog-content>